'use client';

import { DtbTocFeature } from '@/features/dtb/list/DtbTocFeature';
import MainLayout from '@repo-ui/layout/MainLayout';
import type { SchoolYearKey } from '@ocode/domain';
import { useParams, useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

export default function Page() {
  const { yearKey } = useParams<{ yearKey: string }>();
  return (
    <MainLayout>
      <Suspense>
        <PageInternal yearKey={yearKey.toUpperCase() as SchoolYearKey} />
      </Suspense>
    </MainLayout>
  );
}

function PageInternal(props: { yearKey: SchoolYearKey }) {
  const { yearKey } = props;
  const params = useSearchParams();

  const subjectKey = params.get('subject')?.toUpperCase();
  return <DtbTocFeature yearKey={yearKey} subjectKey={subjectKey} />;
}
